export default __webpack_public_path__ + "841de9bfde19047770b73b1f64fb590a.png";